import React from 'react';

import { isCategoryValid } from '~support-at-home/lib/derive';

import { TooltipPortal } from '~components';
import { Row } from '~components/table-view';

import { SahCategory, SahServiceTypeAssociation } from '~lookups/models';

interface ComponentProps {
  row: Row;
  serviceTypeAssocs: SahServiceTypeAssociation[];
  categories: SahCategory[];
}

const ReadOnlyCategory: React.FC<ComponentProps> = ({ row, serviceTypeAssocs, categories }) => {
  const categoryValid = isCategoryValid(row, serviceTypeAssocs, categories);
  const category = categories.find((cat) => cat.id === row.category_id);

  if (categoryValid && category) {
    return <div className="p-1">{category.name}</div>;
  } else {
    // Reached only when the entry's service type genuinely has no association in this category.
    // An entry belonging to a different PERIOD of the same service is no longer flagged here: it
    // resolves to its own association through the category it was saved with, and reads as valid.
    return (
      <>
        <TooltipPortal
          targetId={`${row.id}-missing-category`}
          content="This service type is not associated with a Support at Home service in this category"
        />
        <div className="missing-cell" id={`${row.id}-missing-category`}>
          MISSING
        </div>
      </>
    );
  }
};

export default ReadOnlyCategory;
